module.exports = __webpack_public_path__ + "media/images/store_badges/app_store/app_store_zh-086065560e0ec2de89db4c5c46a45772.png";